import React from 'react';

/** Tailwind skeleton — replaces MUI Skeleton. variant: 'text' | 'rectangular' | 'circular' */
const Skeleton = ({ variant = 'text', width, height, className = '', style = {} }) => {
  const radius =
    variant === 'circular' ? 'rounded-full' : variant === 'text' ? 'rounded' : 'rounded-md';
  return (
    <span
      className={`block animate-pulse bg-slate-200/80 ${radius} ${className}`}
      style={{
        width: width ?? (variant === 'text' ? '100%' : undefined),
        height: height ?? (variant === 'text' ? '1em' : undefined),
        ...style,
      }}
    />
  );
};

export default Skeleton;
